function Impressum() {
    return (
        <div className="Impressum">
            <div className="horizontalDiv row">
                <p className="pagecontent">IMPRESSUM</p>
            </div>
            <div class="container">
                <p className="heading_midsize">Rechtshinweis</p>
                <p>Die Faschingsgesellschaft Eggspatzen Egweil e.V. prüft und aktualisiert die Informationen auf ihren Webseiten regelmäßig.
                    Trotz aller Sorgfalt können sich die Daten zwischenzeitlich verändert haben. Eine Haftung oder Garantie für die Aktualität, Richtigkeit und Vollständigkeit der Informationen kann daher nicht übernommen werden. Gleiches gilt auch für externe Webseiten, auf die über Links verwiesen wird. Die Faschingsgesellschaft Eggspatzen Egweil e.V. ist für den Inhalt der Websites, die aufgrund einer solchen Verbindung erreicht werden, nicht verantwortlich.

                    Des Weiteren behält sich die Faschingsgesellschaft Eggspatzen Egweil e.V. das Recht vor, Änderungen oder Ergänzungen der bereitgestellten Informationen vorzunehmen.
                </p>

                <p className="heading_midsize">Copyright</p>
                <p>
                    Inhalt und Aufbau der Website eggspatzen.de sind urheberrechtlich geschützt.
                    Die Vervielfältigung von Informationen oder Daten, insbesondere die Verwendung von Texten, Textteilen, Grafiken oder Bildmaterial bedarf der vorherigen Zustimmung durch die Faschingsgesellschaft Eggspatzen Egweil e.V.
                </p>
                <img />

                <p className="heading_midsize">Postanschrift</p>
                <p>
                    EGGSPATZEN Egweil e.V. <br></br>
                    1. Präsidentin Christina Schieber <br></br>
                    Eichstätter Straße 2 1/2 <br></br>
                    D-86633 Neuburg a. d. Donau <br></br>
                </p>
            </div>
        </div>
    );
}

export default Impressum;